import { useLang } from "@/i18n";
import { IMG } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/motion";
import { ProjectGallery } from "@/components/ProjectParts";
import { SupportCta } from "@/components/SupportCta";

export default function Team() {
  const { t } = useLang();
  const tm = t.team;
  return (
    <>
      <PageHero eyebrow={tm.eyebrow} lines={tm.titleLines} intro={tm.intro} image={IMG.teamShirts} imageAlt={t.gallery.captions.teamShirts} corner="br" accent="var(--blue)" />
      <section className="py-20 sm:py-28 bg-white" data-testid="team-director">
        <div className="wrap grid gap-12 lg:grid-cols-12">
          <FadeUp className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <div className="aspect-square overflow-hidden petal-bl bg-[var(--blue-pale)] max-w-md">
                <img src={IMG.drDennis} alt={tm.directorName} loading="lazy" className="photo w-full h-full object-cover" />
              </div>
            </div>
          </FadeUp>
          <div className="lg:col-span-7">
            <span className="eyebrow">{tm.directorRole}</span>
            <h2 className="mt-5 text-4xl sm:text-5xl lg:text-6xl leading-tight" data-testid="team-director-name">{tm.directorName}</h2>
            <ol className="mt-10 relative border-l-2 border-[var(--green-pale)] ml-2">
              {tm.directorBio.map((line, i) => (
                <FadeUp as="li" key={i} delay={i * 0.05} className="relative pl-8 pb-8 last:pb-0">
                  <span className={`absolute -left-[9px] top-1.5 w-4 h-4 ${["petal-bl bg-[var(--yellow)]", "petal-tr bg-[var(--coral)]", "petal-br bg-[var(--blue)]"][i % 3]}`} />
                  <p className="text-lg leading-relaxed text-[var(--ink)]">{line}</p>
                </FadeUp>
              ))}
            </ol>
          </div>
        </div>
      </section>
      <section className="py-20 sm:py-28" data-testid="team-president">
        <div className="wrap grid gap-12 lg:grid-cols-12 items-center">
          <div className="lg:col-span-7 lg:order-1 order-2">
            <span className="eyebrow">{tm.presidentRole}</span>
            <h2 className="mt-5 text-4xl sm:text-5xl lg:text-6xl leading-tight" data-testid="team-president-name">{tm.presidentName}</h2>
            <FadeUp as="p" className="mt-8 text-xl sm:text-2xl font-display leading-snug">{tm.presidentBio}</FadeUp>
          </div>
          <FadeUp className="lg:col-span-4 lg:col-start-9 lg:order-2 order-1">
            <div className="aspect-square overflow-hidden petal-tr bg-[var(--coral-pale)] grid place-items-center max-w-sm">
              <img src={IMG.emblem} alt="" loading="lazy" className="w-[76%] h-auto rounded-full" />
            </div>
          </FadeUp>
        </div>
      </section>
      <section className="pt-10 bg-white" data-testid="team-staff">
        <div className="wrap pt-10">
          <h2 className="text-4xl sm:text-5xl">{tm.staffTitle}</h2>
          <p className="mt-5 text-lg leading-relaxed text-[var(--ink-soft)] max-w-3xl">{tm.staffText}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {t.projects.laRomana.specialists.map((s) => <span key={s} className="px-4 py-2 rounded-full bg-[var(--green-pale)] text-[var(--green-deep)] text-sm font-semibold">{s}</span>)}
          </div>
        </div>
        <ProjectGallery keys={["doctors", "staff", "teamShirts", "volunteerChild", "volunteerElderly", "selfie", "drDennis", "kidsBanner"]} />
      </section>
      <SupportCta />
    </>
  );
}
